import React from "react";
import { monthLabel, monthRange, matchingMonth } from "@/lib/ranges";

// Pass 59: the Month / From / To picker, shared by Analytics and
// Conversion tracking so both read "this month" the same way.
export default function RangePicker({ range, months, loading, onChange, testIdPrefix = "analytics" }) {
  const selected = matchingMonth(range);
  const onMonth = (ym) => { if (ym) onChange(monthRange(ym)); };
  const onDate = (field, value) => {
    const next = { ...range, [field]: value };
    if (next.from && next.to) onChange(next);
  };
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 16, alignItems: "flex-end", marginBottom: 28 }}>
      <div>
        <label className="scw-label">Month</label>
        <select className="scw-select" value={selected} onChange={(e) => onMonth(e.target.value)} data-testid={`${testIdPrefix}-month-select`}>
          {!selected && <option value="">Custom range</option>}
          {(months || []).slice().reverse().map((ym) => (
            <option key={ym} value={ym}>{monthLabel(ym)}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="scw-label">From</label>
        <input type="date" className="scw-input" value={range?.from || ""} onChange={(e) => onDate("from", e.target.value)} data-testid={`${testIdPrefix}-from`} />
      </div>
      <div>
        <label className="scw-label">To</label>
        <input type="date" className="scw-input" value={range?.to || ""} onChange={(e) => onDate("to", e.target.value)} data-testid={`${testIdPrefix}-to`} />
      </div>
      {loading && <p style={{ fontSize: 12, color: "var(--scw-muted)" }}>{"Loading…"}</p>}
    </div>
  );
}
